module.exports = __webpack_public_path__ + "img/2021_cellres.d273f951.jpg";